import { useQuery } from "@tanstack/react-query";
import { ArrowLeft, Loader2 } from "lucide-react";
import { useLocation, useParams } from "wouter";
import { AdminSurveyDetailView } from "@/components/surveys/admin-survey-detail-view";
import { ManagerSurveyDetailView } from "@/components/surveys/manager-survey-detail-view";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/hooks/use-auth";
import { useSurveyAccess } from "@/hooks/use-survey-access";
import { orpc } from "@/lib/rpc";

export default function SurveyDetail() {
  const { id } = useParams<{ id: string }>();
  const [, setLocation] = useLocation();
  const { isManager } = useAuth();
  const { canOperateSurveys } = useSurveyAccess();

  const { data: survey, isLoading } = useQuery(
    canOperateSurveys
      ? orpc.pulseSurveys.getDetail.queryOptions({ input: { id: id! } })
      : orpc.pulseSurveys.managerDetail.queryOptions({ input: { id: id! } }),
  );

  if (isLoading) {
    return (
      <div className="flex-1 flex items-center justify-center">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!survey) {
    return (
      <div className="flex-1 flex flex-col items-center justify-center">
        <p className="text-muted-foreground">Pesquisa não encontrada</p>
        <Button variant="outline" className="mt-4" onClick={() => setLocation("/surveys")}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Voltar
        </Button>
      </div>
    );
  }

  if (canOperateSurveys) {
    return <AdminSurveyDetailView survey={survey} />;
  }

  if (isManager) {
    return <ManagerSurveyDetailView survey={survey} />;
  }

  return (
    <div className="flex-1 flex items-center justify-center">
      <p className="text-muted-foreground">Acesso não autorizado</p>
    </div>
  );
}
